import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Header,
  MenuContainer,
  MenuDesk,
  MenuTableMobile,
  Name
} from './styles';
import Image from '../../UI/Image';
import Language from '../../UI/Language';

const HeaderLayout = ({
  title,
  menuOpts,
  handleLanguage,
  languagesOpts,
  expandedMenu,
  handleExpandedMenu
}) => (
  <Container id='home'>
    <Header>
      <Image
        src='/images/logo.png'
        alt='logo-png'
        style={{
          width: '50%',
          maxWidth: '80px',
          margin: '0 35px'
        }}
      />
      <MenuContainer>
        <MenuTableMobile>
          { expandedMenu ? (
              <div className='container-menu-expanded'>
                <div>
                  <p onClick={handleExpandedMenu}>X</p>
                  { menuOpts.map(item =>
                    <a
                      href={item.link}
                      key={item.id}
                      onClick={handleExpandedMenu}
                    >
                      {item.name}
                    </a>
                  )}
                  <Language
                    handleLanguage={handleLanguage}
                    languagesOpts={languagesOpts}
                  />
                </div>
              </div>
            ) : (
              <i onClick={handleExpandedMenu} className='fas fa-bars' />
            )
          }
        </MenuTableMobile>

        <MenuDesk>
          { menuOpts.map(item => <a href={item.link} key={item.id}> {item.name} </a> )}
          <Language handleLanguage={handleLanguage} languagesOpts={languagesOpts} />
        </MenuDesk>
      </MenuContainer>
    </Header>
    <Name>
      { title.map(item => <h1 key={item.id}> {item.text} </h1>)}
      <p>Front End - Mobile React / Back End Node.js</p>
    </Name>
  </Container>
);

HeaderLayout.propTypes = {
  title: PropTypes.array,
  menuOpts: PropTypes.array,
  handleLanguage: PropTypes.func,
  languagesOpts: PropTypes.array,
  expandedMenu: PropTypes.bool,
  handleExpandedMenu: PropTypes.func
};

export default HeaderLayout;
